export default function StructureData(){
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        "name": "Del Mar",
        "image": "https://psitopoleioapostolis.gr/android-chrome-512x512.png",
        "@id": "https://psitopoleioapostolis.gr",
        "url": "https://psitopoleioapostolis.gr",
        "telephone": "+302299075061",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Leof Gregou 10",
          "addressLocality": "Porto Rafti",
          "addressRegion": "Attiki",
          "postalCode": "19003",
          "addressCountry": "Greece"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 37.88808610082315,  
          "longitude": 24.00627140315675
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "17:00",
            "closes": "01:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Saturday",
              "Sunday"
            ],
            "opens": "13:00",
            "closes": "01:00"
          }
        ],
        "servesCuisine": ["Gyro", "Souvlaki"],
        "priceRange": "$"
      };

      return(
        <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
        </script>
      );
}